var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0V20H0V0H20Z",
    fill: "#9A9FA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1445 15.3152H3.85156V14.0443C3.85156 13.7063 4.12815 13.4297 4.46621 13.4297H15.5299C15.868 13.4297 16.1445 13.7063 16.1445 14.0443V15.3152Z",
    fill: "#12ABBF",
    stroke: "#12ABBF",
    strokeWidth: 0.921974,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92852 9.12891V13.4314H5.69922V9.12891H6.92852Z",
    fill: "#12ABBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38555 9.12891V13.4314H8.15625V9.12891H9.38555Z",
    fill: "#12ABBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8426 9.12891V13.4314H10.6133V9.12891H11.8426Z",
    fill: "#12ABBF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3035 9.12891V13.4314H13.0742V9.12891H14.3035Z",
    fill: "#12ABBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23833 15.9688C2.98632 15.9688 2.77734 15.7599 2.77734 15.5079C2.77734 15.2559 2.98632 15.0469 3.23833 15.0469H16.7606C17.0126 15.0469 17.2216 15.2559 17.2216 15.5079C17.2216 15.7599 17.0126 15.9688 16.7606 15.9688H3.23833Z",
    fill: "#12ABBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2294 3.68532C10.1064 3.63614 9.89747 3.63614 9.77454 3.68532L4.2427 5.89805C4.02757 5.9841 3.85547 6.23611 3.85547 6.46968V8.51031C3.85547 8.84837 4.13206 9.12496 4.47012 9.12496H15.5338C15.8719 9.12496 16.1484 8.84837 16.1484 8.51031V6.46968C16.1484 6.23611 15.9763 5.9841 15.7612 5.89805L10.2294 3.68532ZM9.07999 6.66636C9.07999 6.15621 9.4918 5.74439 10.002 5.74439C10.5121 5.74439 10.9239 6.15621 10.9239 6.66636C10.9239 7.17652 10.5121 7.58834 10.002 7.58834C9.4918 7.58834 9.07999 7.17652 9.07999 6.66636Z",
    fill: "#12ABBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e754f14ceb1d476700a0fba85218013c.svg";
export { ForwardRef as ReactComponent };